import React from 'react';
import './ContactInfo.css';

const ContactInfo = ({ config }) => {
  return (
    <div className="contact-info">
        <div className="contact-row">
          <div className="contact-item">
            <h3 className="contact-label">Email</h3>
            <a href={`mailto:${config.email}`} className="contact-value email">
              {config.email}
            </a>
          </div>

          <div className="contact-item">
            <h3 className="contact-label">Phone</h3>
            <a href={`tel:${config.phone}`} className="contact-value phone">
              {config.phone}
            </a>
          </div>
        </div>

        <div className="contact-item">
          <h3 className="contact-label">Address</h3>
          <div className="map-container">
            <img 
              src="/images/contact/map_default_image.jpg" 
              alt="Default Map Image" 
              className="map-default-image"
            />
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3947.2624549045636!2d36.78955069999999!3d-1.2864311000000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f118493ba1a95%3A0xa7510100f0ccfbb8!2sThe%20Arch%20Place!5e1!3m2!1sen!2ssg!4v1761209050387!5m2!1sen!2ssg" 
              width="600" 
              height="450" 
              style={{border:0}} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              className="map-iframe"
            ></iframe>
          </div>
        </div>
      </div>
  );
};

export default ContactInfo;
